import { Page } from 'layouts/Page';
import { FC } from 'react';
import { Pricing } from 'components/Pricing';

export const PricingPage: FC = () => {
	return (
		<Page title="Pricing – EAS Dashboard">
			<Pricing />
		</Page>
	);
};
